
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorInterfaz } from '@view/a-pedido-cargar/controlador';
import { Totales } from '@/views/a-pedido-cargar/controlador-pedido';
import { Moment } from 'moment';

    @Component( {
        name: "Componente",
        props: {},
        components: {

        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorInterfaz;
        public get Tipo() { return this.Controlador.EdicionPedido.Tipo; }
        public get Pedido() { return this.Controlador.Pedido; }
        public get Cliente() { return this.Controlador.EdicionPedido.Cliente; }
        public get Vendedor() { return this.Controlador.EdicionPedido.Vendedor; }
        public get Iniciado() { return this.Controlador.EdicionPedido.Iniciado; }
        public UltimoGuardado: Moment = null;
        public Totales: Totales = new Totales()

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );

        }

        mounted()
        {
            this.Eventos.push( this.Controlador.EdicionPedido.onActualizarTotales.subscribe( () =>
            {
                this.UltimoGuardado = this.Controlador.UltimoGuardado.Fecha;
                this.Totales = this.Controlador.EdicionPedido.Totales;
                this.Refrescar();
            } ) );
        }

        Finalizar()
        {
            this.Controlador.Vista.BarraIzquierda.Modo = 'finalizar';
        }

        public Refresh: boolean = true;
        Refrescar()
        {
            this.Refresh = false;
            this.$nextTick( () => this.Refresh = true );
        }

    }
